import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendNewInvitationMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  message: Types.Scalars['String']['input'];
  workspace_id: Types.Scalars['String']['input'];
  organization_id: Types.Scalars['String']['input'];
  hostname: Types.Scalars['String']['input'];
  user_properties?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  link: Types.Scalars['String']['input'];
  role: Types.Scalars['String']['input'];
}>;


export type SendNewInvitationMutation = { __typename?: 'mutation_root', new_invitation?: { __typename?: 'NewInvitationOutput', success: boolean, invitation_id: string, error?: string | null, invitation?: { __typename?: 'user_invitations', id: any, email: string, status: string, message?: string | null, created_at: any, updated_at: any, workspace_id?: any | null, organization_id?: any | null, properties_ids?: Array<string> | null } | null } | null };


export const SendNewInvitationDocument = gql`
    mutation sendNewInvitation($email: String!, $message: String!, $workspace_id: String!, $organization_id: String!, $hostname: String!, $user_properties: [String], $link: String!, $role: String!) {
  new_invitation(
    email: $email
    message: $message
    workspace_id: $workspace_id
    organization_id: $organization_id
    hostname: $hostname
    user_properties: $user_properties
    link: $link
    role: $role
  ) {
    success
    invitation_id
    error
    invitation {
      id
      email
      status
      message
      created_at
      updated_at
      workspace_id
      organization_id
      properties_ids
    }
  }
}
    `;
export type SendNewInvitationMutationFn = Apollo.MutationFunction<SendNewInvitationMutation, SendNewInvitationMutationVariables>;

/**
 * __useSendNewInvitationMutation__
 *
 * To run a mutation, you first call `useSendNewInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNewInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNewInvitationMutation, { data, loading, error }] = useSendNewInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      message: // value for 'message'
 *      workspace_id: // value for 'workspace_id'
 *      organization_id: // value for 'organization_id'
 *      hostname: // value for 'hostname'
 *      user_properties: // value for 'user_properties'
 *      link: // value for 'link'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSendNewInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendNewInvitationMutation, SendNewInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNewInvitationMutation, SendNewInvitationMutationVariables>(SendNewInvitationDocument, options);
      }
export type SendNewInvitationMutationHookResult = ReturnType<typeof useSendNewInvitationMutation>;
export type SendNewInvitationMutationResult = Apollo.MutationResult<SendNewInvitationMutation>;
export type SendNewInvitationMutationOptions = Apollo.BaseMutationOptions<SendNewInvitationMutation, SendNewInvitationMutationVariables>;